import React from 'react';
import styled from 'styled-components';
const s = require('./header.css');

import Header from 'gi-happy-header/ssr/header';

// import s from './header.css'; // This file is the copy gi-happy-header/ssr/header.css . Copied in the post script command.

const HeaderWrapper = ({ hideHeader, location }) => {
  // TODO: needs to be tested properly
  const handleOnLoginSuccess = () => {
    location.reload();
  };

  const handleOnLogoutSuccess = () => {
    location.reload();
  };

  if (hideHeader) {
    return (
      <Header.HappyHeader
        lobName="flights"
        onLoginSuccess={handleOnLoginSuccess}
        onLogoutSuccess={handleOnLogoutSuccess}
        hideHeader={hideHeader}
      />
    );
  }

  const HeaderStyle = styled.div`
    ${s}
  `;

  return (
    <HeaderStyle>
      <Header.HappyHeader
        lobName="flights"
        onLoginSuccess={handleOnLoginSuccess}
        onLogoutSuccess={handleOnLogoutSuccess}
        hideHeader={hideHeader}
      />
    </HeaderStyle>
  );
};

export default HeaderWrapper;
